import React from 'react';
import AddDeviceRecoveryTab from './AddDeviceRecovery';


function DeviceRecovery ({ tab, userInfo, role, prefilledSystemId, setPrefilledSystemId }) {

    switch (tab) {
        case "Add":
            return <AddDeviceRecoveryTab userInfo={userInfo} prefilledSystemId={prefilledSystemId} setPrefilledSystemId={setPrefilledSystemId} />;
        default:
            return <div className='tab-content'>Content for {tab}</div>;
    }
}

export default DeviceRecovery;
